import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ShipmentToolbar from '../toolbar/shipment-toolbar';
import WorkItemDetailsGrid from '../work-item-details/work-item-details-grid';
import { useShipmentsDateFilterParam } from '../useShipmentsDateFilterParam';
import { IDateRangeFilterValue } from '../../../common/date-range-filter/date-range-filter.interface';
import { shipmentDetails, expediteShipments } from '../../../common/constants/url-constants';
import { useI18nState } from '../../../stores/settings/language-context';
import '../shipments-page.scss';

const initialDateFilter: IDateRangeFilterValue = {
  fromDate: new Date(),
  toDate: new Date(),
  dateFilterType: 1
};

// Standalone Expedites screen - MyWorkItemsDetailsPredicateBuilder scopes Expedites outside the
// Pickup/InTransit/Delivered tab axis entirely (non-standard-service shipments only), so it isn't
// one of the Shipments tabs - it's its own page, reached only from Home's Expedites card.
export default function ExpediteShipmentsPage() {
  const navigate = useNavigate();
  const { localeData } = useI18nState();
  const dateFilterParam = useShipmentsDateFilterParam();
  const [searchText, setSearchText] = useState('');
  const [dateFilter, setDateFilter] = useState<IDateRangeFilterValue>(
    dateFilterParam ?? initialDateFilter
  );

  const handleShipmentIdClick = (shipment: { shipmentNumber: string }) => {
    const path = shipmentDetails.replace(
      ':shipmentNumber',
      shipment.shipmentNumber
    );
    navigate(path, {
      state: {
        breadCrumbLinks: [
          { title: localeData.ExpediteShipments, path: expediteShipments },
          { title: shipment.shipmentNumber }
        ]
      }
    });
  };

  return (
    <div className="shipments-page" data-testid="expedite_shipments_page">
      <ShipmentToolbar
        searchText={searchText}
        onSearchTextChange={setSearchText}
        dateFilter={dateFilter}
        onDateFilterChange={setDateFilter}
      />

      <div className="shipments-content-area">
        <WorkItemDetailsGrid
          tab="Expedites"
          dateFilter={dateFilter}
          searchText={searchText}
          onShipmentIdClick={handleShipmentIdClick}
        />
      </div>
    </div>
  );
}
